export class UserProfileModel {
    username: string;
    password: string;
    isActive: boolean;
    status: boolean;
    Email: string;
    PatientID: string;
    dob: string;
    UserName: string;
    age: string;
    mobile: string;
    RegistrationDate:string;
    SponsorCode: string;
    Sex: string;
    ImageByte: string;
    SessionTimeout: string;
    SponsorName: string;
    PolicyNo: string;
    Validity: string; 
    CompImageByte: string;
    IsFeedBackAvailable: string;
    ValidUser: boolean;
    AppointmentRequest: boolean;
    LabRequest: boolean;
    RadiologyRequest: boolean;
	PatienName:string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/userprofile/userprofiledatamodel.ts